<template>
  <div>
     <ul class="online-users">
       <li class="clearfix" v-for="(user, index) in usersOnPage" :key="index" :style="{backgroundColor: user.color}">
         <div class="float-left">
           {{ user.name.charAt(0).toUpperCase() }}
         </div> 
         <div class="float-left">
           {{ user.name }}
         </div>
       </li>
     </ul>
  </div>
</template>

<script>
  export default {
     props: {
       currentlyOnPage: {
         type: Object,
         default: {}
       }
     },
     computed : {
        usersOnPage(){
           let users = []
           for(const id in this.currentlyOnPage){
               users.push({name: this.currentlyOnPage[id], color: this.generateRandomColor() })
           }

           let uniqueUsers = [];
           let usernames = [];

           users.forEach(user => {
              if(!usernames.includes(user.name)){
                 uniqueUsers.push(user);
                 usernames.push(user.name);
              }
           })
           return uniqueUsers;
        },
     },
     methods: {
       generateRandomColor() {
             var letters = '012345'.split('');
              var color = '#';        
              color += letters[Math.round(Math.random() * 5)];
              letters = '0123456789ABCDEF'.split('');
              for (var i = 0; i < 5; i++) {
                  color += letters[Math.round(Math.random() * 15)];
              }
              return color;
          },
        
     }
  }
</script>

<style lang="scss" scoped>
  .online-users {
     list-style-type: none;
     padding-left:0;
     margin-bottom: 0;
     li{
       display: inline-block;
       padding: 5px 15px;
       font-size: 12px;
       background-color: black;
       color: #fff;
       margin-right: 5px;
       border-radius: 20px;
       border: 1px solid #fff;
       width: 40px;
       height: 40px;
       box-shadow: 1px 1px 5px rgba(0,0,0,0.1);
       overflow:hidden;
       cursor: pointer;
       
      div:nth-child(1){
        margin-top: 5px;
      }
      div:nth-child(2){
        max-width: 0;
        overflow: hidden;
        transition: all 2s ease;
        margin-top: 5px;
      } 
      &:hover{
          width: auto;
      }
      &:hover  div:nth-child(2){
         max-width: 200px;
         transition: all 2s ease;
      } 
      &:hover  div:nth-child(1){
        width: 0;
        overflow:hidden;
      }
     }
       
  }
</style>